import { render, staticRenderFns } from "./strengths.vue?vue&type=template&id=5be4682c&scoped=true&"
import script from "./strengths.vue?vue&type=script&lang=js&"
export * from "./strengths.vue?vue&type=script&lang=js&"
import style0 from "./strengths.vue?vue&type=style&index=0&id=5be4682c&lang=scss&scoped=true&"
import style1 from "./strengths.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5be4682c",
  null
  
)

export default component.exports